import Col from "react-bootstrap/Col";
import Row from "react-bootstrap/Row";
import React, {useState} from "react";
import {FaEye} from "react-icons/fa";
import moment from "moment"

export default function IndependentClassCard(props) {
    const [isHovered, setHovered] = useState(false);

    // console.log(props.name)
    // console.log(props.topic)

    // console.log("session class status", props.name)
    // console.log("session class status", props.topic)

    return (
        <Col xs={12} sm={6} md={props.customMD ? props.customMD : 4} style={{marginTop: 50, cursor: 'pointer'}} onClick={props.onClick}
             onMouseOver={() => setHovered(true)} onMouseLeave={() => setHovered(false)}>
            <div style={{position: 'relative', transition: 'height 5s'}}>
                <img src={props.image}
                     style={{width: '100%', height: 320, objectFit: 'contain'}}/>

                <div style={{
                    position: 'absolute',
                    top: '50%',
                    left: '50%',
                    transform: 'translate(-50%, -50%)',
                    height: '100%',
                    width: '100%',
                    backgroundColor: '#133c57E6',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    opacity: isHovered ? 1 : 0,
                    transition: 'opacity 0.8s'
                }}>
                    <FaEye style={{
                        fontSize: 30,
                        color: "white"
                    }}/>
                    {/*<img src={'gif/eye.gif'} style={{width: 50}}/>*/}
                </div>
            </div>

            <div style={{fontSize: 20, marginTop: 15, color: '#4f4f4f'}}>
                {props.title}
            </div>

            <div style={{fontSize: 15, marginTop: 10, fontWeight: '300', color: '#4f4f4f'}}>
                {typeof props.topic === "string" && typeof props.title === "string" ? props.topic : null}
            </div>

        </Col>
    )


}
